import { WithLangs } from '@common/typescript/objects/Page';
import { Lang } from '@common/typescript/objects/Lang';

import { NTPage, Page, PageInfo } from '@commonTuna/react/objects/Page';

export const getPageInfo = (item: WithLangs<PageInfo>): PageInfo | undefined => {
	return item.langs.length > 0 ? (item.langs.find((langItem) => langItem.language === Lang.En) || item.langs[0]) : undefined;
};

export const getPageShortName = (item: NTPage): string => {
	return item.shortNameEn || item.name;
};

export const t = (key) => {
	return {
		'site.Click to see results': 'Click to see results',
		'site.Services': 'Services',
		'forms.Gender': 'Gender',
		'forms.Ethnicity': 'Ethnicity',
		'forms.Age': 'Age',
		'forms.Weight': 'Weight',
		'forms.Height': 'Height',
		'forms.Pre-op Size': 'Pre-op Size',
		'forms.Left Implant': 'Left Implant',
		'forms.Right Implant': 'Right Implant',
		'site.Description': 'Description',
		'forms.Post-op Size': 'Post-op Size',
		'forms.Male': 'Male',
		'forms.Female': 'Female',
		'forms.Other': 'Other',
	}[key];
};

export const lockText = 'This feature contains nudity. Please click OK to confirm you'
	+ ' are at least 18 years of age and are not offended by such material.';

export const getBackgroundUrl = (image: string) => {
	return `url("${image?.replace('\\', '/')}")`;
};
